import React from 'react';
import { IconBox, IconProps } from 'src/lib/IconBox';

const OverflowMenuIcon = (props: IconProps) => (
  <IconBox {...props}>
    <circle cx="8" cy="32" r="8" />
    <circle cx="32" cy="32" r="8" />
    <circle cx="56" cy="32" r="8" />
  </IconBox>
);

export default OverflowMenuIcon;
